/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CaseTimelineEntryListResponse = zod
	.array(
		zod
			.object({
				actor_id: zod.uuid().optional().describe('Actor ID'),
				actor_type: zod.string().describe('Actor type: system, praetor, user, api'),
				case_id: zod.uuid().describe('Case ID'),
				description: zod.string().optional().describe('Human-readable description'),
				event: zod.string().describe('Event type'),
				id: zod.uuid().describe('Entry ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				metadata: zod.looseObject({}).describe('Event-specific metadata'),
				subject_id: zod.uuid().optional().describe('Subject ID'),
				subject_type: zod.string().optional().describe('Subject type')
			})
			.describe('A case timeline entry')
	)
	.describe('List of case timeline entries');

export type CaseTimelineEntryListResponse = zod.input<typeof CaseTimelineEntryListResponse>;
export type CaseTimelineEntryListResponseOutput = zod.output<typeof CaseTimelineEntryListResponse>;
